<template lang="pug">

    .ui.input(v-bind:class='classes')

        //- ggf. Prefix
        .ui.label(v-if='field.prefix') {{ field.prefix }}

        input(
            type='number'
            v-bind:value='value[field.id]'
            v-on:input='updateValue($event.target.value)'
        )

        //- Suffix
        .ui.label(v-if='field.suffix') {{ field.suffix }}

</template>

<script>
    import { maybe } from 'maybes'

    export default {
        name: "ProductFormsVariantFormsFormFieldNumberField",

        computed: {
            classes() {
                return {
                    right: maybe(this.field.suffix).isJust(),
                    labeled: maybe(this.field.suffix).isJust() || maybe(this.field.prefix).isJust()
                }
            },
        },

        methods: {
            updateValue(value) {
                this.$emit('input', { ...this.value, [this.field.id]: value })
            }
        },

        props: {
            field: {
                type: Object,
                required: true
            },
            value: {
                required: true
            }
        }

    }

</script>
